export const LPR_EXPORT_TOAST_TIMEOUT = 60000;
